import POWER from '../../assets/photos/strength.jpeg'
import YOGA from '../../assets/photos/yoga.jpeg'
import SPINNING from '../../assets/photos/spinning.jpeg'
import BOX from '../../assets/photos/boxing.jpeg'

const classesByDay = {
    Monday: [
        { name: `CrossFit Training (Group Class)`, time: '06:00 AM - 07:00 AM', trainer: 'Jaiveer Yadav', img:POWER },
        { name: 'Weight Loss', time: '07:30 AM - 08:30 AM', trainer: 'Jaiveer Yadav', img:SPINNING },
        { name: 'Strength Training', time: '08:30 AM - 09:30 AM', trainer: 'Jaiveer Yadav', img:YOGA },
        { name: 'Weight Loss(Group Class)', time: '10:30 AM - 11:30 AM', trainer: 'Jaiveer Yadav', img:BOX },

        { name: `Gymnastics Basics for Kids`, time: '04:00 PM - 05:15 PM', trainer: 'Jaiveer Yadav', img:POWER },
        { name: `Gymnastics Advance Training`, time: '05:00 PM - 06:30 PM', trainer: 'Jaiveer Yadav', img:YOGA },
      ],
      Tuesday: [
        { name: `CrossFit Training (Group Class)`, time: '06:00 AM - 07:00 AM', trainer: 'Jaiveer Yadav', img:POWER },
        { name: 'Weight Loss', time: '07:30 AM - 08:30 AM', trainer: 'Jaiveer Yadav', img:SPINNING },
        { name: 'Strength Training', time: '08:30 AM - 09:30 AM', trainer: 'Jaiveer Yadav', img:YOGA },
        { name: 'Weight Loss(Group Class)', time: '10:30 AM - 11:30 AM', trainer: 'Jaiveer Yadav', img:BOX },

        { name: `Gymnastics Basics for Kids`, time: '04:00 PM - 05:15 PM', trainer: 'Jaiveer Yadav', img:POWER },
        { name: `Gymnastics Advance Training`, time: '05:00 PM - 06:30 PM', trainer: 'Jaiveer Yadav', img:YOGA },
      ],
      Wednesday: [
        { name: `CrossFit Training (Group Class)`, time: '06:00 AM - 07:00 AM', trainer: 'Jaiveer Yadav', img:POWER },
        { name: 'Weight Loss', time: '07:30 AM - 08:30 AM', trainer: 'Jaiveer Yadav', img:SPINNING },
        { name: 'Strength Training', time: '08:30 AM - 09:30 AM', trainer: 'Jaiveer Yadav', img:YOGA },
        { name: 'Weight Loss(Group Class)', time: '10:30 AM - 11:30 AM', trainer: 'Jaiveer Yadav', img:BOX },

        { name: `Dance Class`, time: '04:00 PM - 05:15 PM', trainer: 'Jaiveer Yadav', img:POWER },
        { name: `Dance Class`, time: '05:00 PM - 06:30 PM', trainer: 'Jaiveer Yadav', img:YOGA },
      ],
      Thursday: [
        { name: `CrossFit Training (Group Class)`, time: '06:00 AM - 07:00 AM', trainer: 'Jaiveer Yadav', img:POWER },
        { name: 'Weight Loss', time: '07:30 AM - 08:30 AM', trainer: 'Jaiveer Yadav', img:SPINNING },
        { name: 'Strength Training', time: '08:30 AM - 09:30 AM', trainer: 'Jaiveer Yadav', img:YOGA },
        { name: 'Weight Loss(Group Class)', time: '10:30 AM - 11:30 AM', trainer: 'Jaiveer Yadav', img:BOX },

        { name: `Gymnastics Basics for Kids`, time: '04:00 PM - 05:15 PM', trainer: 'Jaiveer Yadav', img:POWER },
        { name: `Gymnastics Advance Training`, time: '05:00 PM - 06:30 PM', trainer: 'Jaiveer Yadav', img:YOGA },
      ],
      Friday: [
        { name: `CrossFit Training (Group Class)`, time: '06:00 AM - 07:00 AM', trainer: 'Jaiveer Yadav', img:POWER },
        { name: 'Weight Loss', time: '07:30 AM - 08:30 AM', trainer: 'Jaiveer Yadav', img:SPINNING },
        { name: 'Strength Training', time: '08:30 AM - 09:30 AM', trainer: 'Jaiveer Yadav', img:YOGA },
        { name: 'Weight Loss(Group Class)', time: '10:30 AM - 11:30 AM', trainer: 'Jaiveer Yadav', img:BOX },

        { name: `Gymnastics Basics for Kids`, time: '04:00 PM - 05:15 PM', trainer: 'Jaiveer Yadav', img:POWER },
        { name: `Gymnastics Advance Training`, time: '05:00 PM - 06:30 PM', trainer: 'Jaiveer Yadav', img:YOGA },
      ],
      Saturday: [
        { name: `CrossFit Training (Group Class)`, time: '06:00 AM - 07:00 AM', trainer: 'Jaiveer Yadav', img:POWER },
        { name: 'Weight Loss', time: '07:30 AM - 08:30 AM', trainer: 'Jaiveer Yadav', img:SPINNING },
        { name: 'Strength Training', time: '08:30 AM - 09:30 AM', trainer: 'Jaiveer Yadav', img:YOGA },
        { name: 'Weight Loss(Group Class)', time: '10:30 AM - 11:30 AM', trainer: 'Jaiveer Yadav', img:BOX },

        { name: `Dance Class`, time: '04:00 PM - 05:15 PM', trainer: 'Jaiveer Yadav', img:POWER },
        { name: `Dance Class`, time: '05:00 PM - 06:30 PM', trainer: 'Jaiveer Yadav', img:YOGA },
      ],
  };

export default classesByDay;